exports.components = {
  "component---src-pages-aboutus-js": () => import("./../../../src/pages/aboutus.js" /* webpackChunkName: "component---src-pages-aboutus-js" */),
  "component---src-pages-contact-page-js": () => import("./../../../src/pages/contact_page.js" /* webpackChunkName: "component---src-pages-contact-page-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-privacy-page-js": () => import("./../../../src/pages/privacy_page.js" /* webpackChunkName: "component---src-pages-privacy-page-js" */)
}

